function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export var FollowButton = function (_React$Component) {
  _inherits(FollowButton, _React$Component);

  function FollowButton() {
    var _temp, _this, _ret;

    _classCallCheck(this, FollowButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.authAndFollow = function () {
      _this.props._auth.postAuthFollow(_this.props.merchant);
      _this.props._auth.postAuthRedirect(_this.props.location.pathname);
      _this.props._auth.toggleAuthenticationModal();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  FollowButton.prototype.render = function render() {
    var _props = this.props,
        auth = _props.auth,
        merchant = _props.merchant,
        onClick = _props.onClick;


    return React.createElement(
      'button',
      {
        className: classNames('FollowButton d-inline-block', {
          active: merchant.followed
        }),
        onClick: auth.get('user').get('isLoggedIn') ? onClick : this.authAndFollow
      },
      React.createElement(
        'span',
        { className: 'd-inline-flex align-items-center follow-button-container btn-pill' },
        React.createElement('i', {
          className: classNames('follow-button-icon-bg fa fa-heart'),
          'aria-hidden': 'true'
        }),
        React.createElement(
          'span',
          {
            className: 'follow-button-text'
          },
          merchant.followed ? 'Following' : 'Follow'
        ),
        React.createElement('i', {
          className: classNames('follow-button-icon fa', {
            'fa-heart-o': !merchant.followed,
            'fa-heart': merchant.followed
          }),
          'aria-hidden': 'true'
        })
      )
    );
  };

  return FollowButton;
}(React.Component);

FollowButton.PropTypes = {
  auth: PropTypes.object.isRequired,
  merchant: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired
};


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/FollowButton.js
// module id = 767
// module chunks = 4